<template>
	<div>
		<loader v-if="loader" :color="'white'"></loader>
		<div class="container">
			<!-- raspored naslov -->
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Raspored</h3>
						</div>
					</div>
				</div>
				<div class="col-12 biz-title-container mb-3">
					<div class="container">
						<ul class="nav nav-tabs" id="raspored-tab" role="tablist">
							<!--
							<li class="nav-item">
								<a class="nav-link active" id="raspored-tab1" data-toggle="tab" href="#raspored1" role="tab" aria-controls="raspored1" aria-selected="true">Raspored</a>
							</li>
							-->
							<li class="nav-item">
								<a class="nav-link active" id="radno-vrijeme-tab1" data-toggle="tab" href="#radno-vrijeme1" role="tab" aria-controls="radno-vrijeme1" aria-selected="true">Radno vrijeme</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="row tab-content" id="rasporedTabContent">
				<!--
				<div id="raspored1" class="col-12 salon-container mb-3 tab-pane fade show active" role="tabpanel" aria-labelledby="raspored-tab1">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div class="col-12">
								<div class="termini-title biz-content-heading">
									<a class="btn fs-btn arrow-border" href="#" @click="getPrevWeek()">
										<i class="fa fa-arrow-left"></i>
									</a>
									<h5>{{format_croatia_date(start)}}. - {{format_croatia_date(end)}}.</h5>
									<a class="btn fs-btn arrow-border" href="#" @click="getNextWeek()">
										<i class="fa fa-arrow-right"></i>
									</a>
								</div>
								<form id="" class="form-horizontal">
									<div class="table-responsive">
										<table id="raspored-tbl" class="table table-sm table-borderless">
											<thead class="text-center">
												<th>
													<small>Djelatnik</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 0))}}</div>
													<small>Pon</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 1))}}</div>
													<small>Uto</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 2))}}</div>
													<small>Sri</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 3))}}</div>
													<small>Čet</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 4))}}</div>
													<small>Pet</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 5))}}</div>
													<small>Sub</small>
												</th>
												<th>
													<div>{{format_croatia_day(intervalDate(new Date(start) , 6))}}</div>
													<small>Ned</small>
												</th>
											</thead>
											<tbody v-if="!loadingSchedule">
												<tr class="raspored-tr" v-for="(shift , index1) in schedules" :key="index1">
													<td class="px-1 schedEmpl"><small>{{shift.employee.name}}</small></td>

													<td v-for="(sched,index) in shift.schedules" :class=" getDay() == index+1 && current_date.getWeekNumber() == new Date().getWeekNumber() ? 'schedHighlight':''" :key="index">

														<select @click="getValueBeforeChanges(shift,sched)" v-model="sched.value" class="custom-select">
															<option value="0"></option>
															<option style=" color: #000; font-weight: 700; text-indent: 10px;" v-for="(shift,index) in user.salon.shifts" :key="index" :value="shift.id">{{shift.abbreviation}}</option>
														</select>

													</td>

												</tr>
											</tbody>
										</table>
									</div>
								</form>
								<div class="btn-xs-group btn-xs-group-block mt-3">
									<button v-if="!loadingSchedule" @click="saveSchedule()" id="submit" type="button" class="btn fs-btn dark btn-xs-block mr-auto">
										<span>AŽURIRAJ TJEDAN</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				-->
				<div id="radno-vrijeme1" class="col-12 salon-container mb-3 tab-pane fade show active" role="tabpanel" aria-labelledby="radno-vrijeme-tab1">
					<!--
					<div class="container mb-5">
						<div class="row no-gutters smjene">
							<div v-for="(shift,index) in user.salon.shifts" :key="index" class="col-12 jutro">
								<div class="d-flex">
									<div class="mr-auto td-flex">
										<div class="mr-3">
											<div class="smjena-abb">{{shift.abbreviation}}</div>
										</div>
										<div class="">
											<h5>{{shift.name}}</h5>
											<p>{{shift.start.substr(0,5)}} - {{shift.end.substr(0,5)}}</p>
										</div>
									</div>
									<div class="ml-auto pr-3 td-flex">
										<a href="#" @click="deleteShift(shift.id)" class="btn fs-btn small danger-border float-right">
											<i class="fas fa-trash"></i>
										</a>
									</div>
								</div>
							</div>
							<div class="btn-xs-group btn-xs-group-block mt-3">
								<a href="#" data-toggle="modal" data-target="#newSmjeModal" class="btn fs-btn dark btn-xs-block">Dodaj smjenu <span class="fas fa-plus fa-fw"></span></a>
							</div>
						</div>
					</div>
					-->
					<div class="container mb-3">
						<div class="row no-gutters">

							<form id="radno-vrijeme" class="form-horizontal col-12">
								<div class="table-responsive">
									<table class="table table-borderless table-sm table-striped table-highlight">
										<thead class="text-center">
											<th></th>
											<th>Početak</th>
											<th><span id="basic-addon1"><i class="fas fa-sign-out-alt fa-fw"></i></span></th>
											<th><span id="basic-addon1"><i class="fas fa-sign-in-alt fa-fw"></i></span></th>
											<th>Kraj</th>
										</thead>
										<tbody>
											<tr v-for="(day,index) in days" :key="index">
												<td>{{day.day}}</td>
												<td>
													<input type="time" v-model="day.data.start" name="" id="">
													<!-- <select v-model="day.data.start" name="" id="" > -->
													<!-- <option v-for="(tym,index) in time" :key='index' :value="tym.value">{{tym.label}}</option> -->
													<!-- </select> -->
												</td>
												<td>
													<input type="time" v-model="day.data.ps" name="" id="">
													<!-- <select v-model="day.data.ps" name="" id="" > -->
													<!-- <option v-for="(tym,index) in time" :key='index' :value="tym.value">{{tym.label}}</option> -->
													<!-- </select> -->
												</td>
												<td>
													<input type="time" v-model="day.data.pk" name="" id="">
													<!-- <select v-model="day.data.pk" name="" id="" > -->
													<!-- <option v-for="(tym,index) in time" :key='index' :value="tym.value">{{tym.label}}</option> -->
													<!-- </select> -->
												</td>
												<td>
													<input type="time" v-model="day.data.end" name="" id="">
													<!-- <select v-model="day.data.end" name="" id="" > -->
													<!-- <option v-for="(tym,index) in time" :key='index' :value="tym.value">{{tym.label}}</option> -->
													<!-- </select> -->
												</td>
											</tr>
										</tbody>
									</table>
									<div class="mt-2 mb-2 ml-1">
										<div v-if="shedulemessage">
											<notify></notify>
										</div>
									</div>
								</div>
								<button @click="save()" type="button" class="fs-btn dark text-uppercase btn-lg btn-xs-block mt-3">
									<span>SPREMI</span>
								</button>
							</form>

						</div>
					</div>
				</div>
			</div>

			<!-- smjena modal -->
			<div class="modal animated fadeIn" id="newSmjeModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Nova smjena</h4>
							<button id="closeShift" type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<form id="" action="" method="post">
								<div class="row">
									<div class="col-7 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="fas fa-quote-right fa-fw"></i></span>
										</div>
										<input id="datum" v-model="shift.name" name="datum" type="text" class="form-control" placeholder="Naziv smjene" aria-label="ime" aria-describedby="Naziv smjene" required>
									</div>
									<div class="col-5 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="fas fa-font fa-fw"></i></span>
										</div>
										<input id="datum" v-model="shift.abbreviation" name="datum" type="text" class="form-control" placeholder="Slovo" aria-label="Slovo" aria-describedby="Slovo" required maxlength="1">
									</div>
								</div>
								<div class="row">
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="fas fa-sign-in-alt fa-fw"></i></span>
										</div>
										<input v-model="shift.start" id="smjenaStart" name="smjenaStart" type="time" class="form-control" placeholder="Početak" aria-label="Početak" aria-describedby="Početak smjene" required>
									</div>
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="fas fa-sign-out-alt fa-fw"></i></span>
										</div>
										<input v-model="shift.end" id="smjenaKraj" name="smjenaKraj" type="time" class="form-control" placeholder="Kraj" aria-label="kraj" aria-describedby="kraj smjene" required>
									</div>
								</div>
								<div v-if="shiftmessage">
									<notify></notify>
								</div>
								<button @click="createShift()" type="button" class="fs-btn dark text-uppercase btn-lg btn-block">
									<span> Spremi </span>
								</button>
							</form>
						</div>
						<div id="book-modal-footer" class="modal-footer">
						</div>
					</div>
				</div>
			</div>

			<div class="modal animated fadeIn" id="changeEmployee" tabindex="-1" role="dialog" aria-labelledby="changeEmployeeLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Promjena rasporeda</h4>
							<button id="closeEmployee" type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<div class="row">
								<div class="col-12">
									<div class="alert alert-danger">
										<h5>Otkažite termine kako biste mogli promijeniti smjenu.</h5>
									</div>
								</div>
							</div>
							<div v-for="(affected,index) in affecteds" :key="index" class="row">
								<div v-for="(book,index) in affected.bookings" :key="index" class="col-12 rezervacije-div">
									<div class="rezervacije-left">
										<p class="rezervacije-color">{{book.datee}} u {{book.time}} </p>
										<div class="rezervacije-bold">{{book.employee.name}}</div>
										<div>{{book.service_names}}</div>
										<div>{{book.customer.name}}</div>
										<!-- <div>{{book.time_total}} Mins | {{book.price}} Kn</div> -->
									</div>
									<div class="rezervacije-right">
										<div class="rezervacije-btns">
											<div v-if="book.status != -1">
												<button @click="reject(book.employee.id,book.id)" class="btn btn-sm btn-danger bg-danger">Otkaži</button>
											</div>
										</div>
									</div>
									<!-- <a class="viewBtn" href="#viewModal" data-toggle="modal">view all</a> -->
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-12">
									<div class="btn-xs-group">
										<a @click="cancelChanges()" class="btn fs-btn dark btn-xs-group-block" data-dismiss="modal">NATRAG</a>
										<a @click="saveSchedule()" class="btn fs-btn danger-border btn-xs-group-block" data-dismiss="modal">SPREMI</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal animated fadeIn" id="">
				<div class="modal-dialog modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<h4 class="modal-title">Promjena rasporeda</h4>
						</div>
						<div class="modal-body">
							<div class="alert alert-danger">
								<h4>Otkažite termine kako biste mogli promijeniti smjenu.</h4>
							</div>
							<div class="affected mb-3" v-for="(affected,index) in affecteds" :key="index">
								<div v-for="(book,index) in affected.bookings" :key="index" class="col-12 rezervacije-div d-flex">
									<div class="rezervacije-left">
										<p style="color: red;font-weight: 600;" class="rezervacije-date">{{book.datee}} u {{book.time}}{{getMer(book.time)}} </p>
										<p>{{book.service_names}}</p>
										<p>{{book.time_total}} Mins | {{book.price}} Kn</p>
										<p class="rezervacije-username">{{book.employee.name}}</p>
									</div>
									<div class="rezervacije-right">
										<div class="rezervacije-btns">
											<div v-if="book.status != -1" class="rezervacije-right text-mute">
												<button @click="reject(book.employee.id,book.id)" class="btn btn-danger bg-danger">Otkaži</button>
											</div>
											<div v-if="book.status == 1" class="rezervacije-right text-success">
												Potvrđeno
											</div>
											<div v-if="book.status == -1" class="rezervacije-right text-danger">
												Otkazano
											</div>
											<div v-if="book.status == 0" class="rezervacije-right text-warning">
												Čeka na potvrdu
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form-group mt-5 d-flex" style="justify-content:space-between">
								<button @click="cancelChanges()" data-dismiss='modal' class="btn btn-danger bg-danger">OTKAŽI PROMJENE</button>

								<button @click="saveSchedule()" data-dismiss='modal' class="btn btn-success bg-success">PROMJENI SMJENU</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	import {
		module_mixin
	} from '../../../mixins/index'
	export default {
		mixins: [module_mixin],
		data() {
			return {
				// time:[{label:'6 AM',value:6},{label:'7 AM',value:7},{label:'8 AM',value:8},{label:'9 AM',value:9},{label:'10 AM',value:10},{label:'11 AM',value:11},{label:'12 PM',value:12},{label:'1 PM',value:13},{label:'2 PM',value:14},{label:'3 PM',value:15},{label:'4 PM',value:16},{label:'5 PM',value:17},{label:'6 PM',value:18},{label:'7 PM',value:19},{label:'8 PM',value:20},{label:'9 PM',value:21},{label:'10 PM',value:22},{label:'11 PM',value:23}],
				days: [{
						day: 'Pon',
						value: 'Mon',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Uto',
						value: 'Tue',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Sri',
						value: 'Wed',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Čet',
						value: 'Thu',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Pet',
						value: 'Fri',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Sub',
						value: 'Sat',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					},
					{
						day: 'Ned',
						value: 'Sun',
						data: {
							start: '',
							ps: '',
							pk: '',
							end: ''
						}
					}
				],
				schedules: [],
				shift: {
					name: '',
					abbreviation: '',
					start: '',
					end: ''
				},
				current_date: new Date(),
				start: '',
				end: '',
				shedulemessage: false,
				shiftEmplmessage: false,
				shiftmessage: false,
				loader: false,
				schedule_loader: false,
				loadingSchedule: false,
				valueBeforeChanges: 0,
				shiftChange: {
					shift: {},
					employee: {}
				},
				re_assign_loader: false,
				affecteds: []
			}
		},
		computed: {
			...mapState({
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
				notification: (state) => state.notification,
				user: (state) => state.user,
			}),
			background() {
				return this.shift.color;
			}
		},
		methods: {
			...mapMutations({
				setNotif: 'setNotification',
				setLoader: 'setLoader',
			}),
			reject(empl_id, id) {
				if (confirm("Jeste li sigurni da želite odbaciti ovu rezervaciju?")) {
					this.response_loading = true;

					this.$store.dispatch('post', {
							endpoint: this.endpoint + 'reject-booking/' + id + '?token=' + this.token,
							details: {
								note: ''
							}
						})
						.then((data) => {
							// console.log(data);
							this.response_loading = false;
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						})
						.catch((error) => {
							console.log(error.request);
							this.response_loading = false;
						});

					var temp = this.affecteds.map((affected) => {
						if (affected.id == empl_id) {
							affected.bookings = affected.bookings.map((book) => {
								if (book.id == id) {
									book.status = -1;
								}
								return book;
							})
						}
						return affected;
					});
					this.affecteds = temp;
				}
			},
			intervalDate(date, interval) {
				var dt = new Date(date);
				dt.setDate(dt.getDate() + parseInt(interval));
				return dt;
			},
			changeEmployee() {
				if (this.re_assign_loader) {
					return false;
				}
				var check = this.shiftChange.data.filter((d) => d.employee == 0);
				if (check.length > 0) {
					this.setNotif({
						type: 2,
						msg: "Please re-assign employees for all booking within this shift"
					});
				}

				this.re_assign_loader = true;
				this.$store.dispatch('post', {
					details: {
						reassign_details: JSON.stringify(this.shiftChange.data)
					},
					endpoint: this.endpoint + 're-assign-appointments?token=' + this.token
				}).then((data) => {
					console.log(data);
					if (data.data.status) {
						this.setNotif({
							type: 1,
							msg: "Appointment was re-assigned successfully"
						});
						window.location.reload();
					} else {
						this.setNotif({
							type: 2,
							msg: data.data.message
						});
					}
					this.re_assign_loader = false;
				}).catch((error) => {
					console.log(error.request);
					this.setNotif({
						type: 2,
						msg: "Opps server error occured"
					});
					this.re_assign_loader = false;
				});
			},
			cancelChanges() {
				this.updateSchedule(this.valueBeforeChanges.employee.id, this.valueBeforeChanges.day, this.valueBeforeChanges.value);
			},
			getService(service) {
				return JSON.parse(service);
			},
			getMer(time) {
				return time.split(':')[0] <= 12 ? 'AM' : 'PM';
			},
			getValueBeforeChanges(shift, schd) {
				this.valueBeforeChanges = schd;
				this.valueBeforeChanges = { ...this.valueBeforeChanges,
					...shift
				};
			},
			updateSchedule(empl, day, value) {
				// console.log(empl, day);
				this.schedules = this.schedules.map((d) => {
					if (d.employee.id == empl) {
						d.schedules = d.schedules.map((schd) => {
							if (schd.day == day) {
								schd.value = value;
							}
							return schd;
						});
					}
					return d;
				});
				// console.log(this.schedules);
			},
			checkIfHasBooking(empl_index, day_index, newShift) {
				var employee = this.user.salon.employees[empl_index];
				var shift = this.user.salon.shifts.find((shf) => shf.id == this.valueBeforeChanges.value);
				if (!shift) {
					return false;
				}
				var day = new Date(this.valueBeforeChanges.start);
				day.setDate(day.getDate() + day_index);
				var date = this.formatDate(day);
				// var schedule=this.valueBeforeChanges.schedules[day_index]; 
				var hours = this.getHoursBetween(shift.start, shift.end);
				var bookings = employee.booking.filter((e) => e.date == date); //filtering date
				bookings = bookings.filter((d) => hours.find((w) => w == parseInt(d.time.split(':')))); //filtering time
				if (bookings.length == 0) {
					return false;
				} else {
					var temp = bookings.map((d) => {
						return {
							id: d.id,
							employee: 0
						};
					});
					this.shiftChange.date = date;
					this.shiftChange.shift = shift;
					this.shiftChange.newShift = newShift;
					this.shiftChange.bookings = bookings;
					this.shiftChange.employee = employee;
					this.shiftChange.data = temp;
					window.$("#changeEmployee").modal('show');
				}
				// console.log(this.shiftChange); 
			},
			getHoursBetween(start, end) {
				start = parseFloat(start.replace(':', '.'));
				end = parseFloat(end.replace(':', '.'));
				var hours = [];
				while (start <= end) {
					hours.push(start);
					start += 1;
				}
				return hours;
			},
			formatDate(date) {
				return date.getFullYear() + '-' + this.reformatMonth((date.getMonth() + 1)) + '-' + date.getDate();
			},
			reformatMonth(month) {
				return month.toString().length > 1 ? month + ' ' : '0' + month;
			},
			deleteShift(id) {
				if (confirm("Jeste li sigurni da želite ukloniti ovu smjenu?")) {
					this.$store.dispatch('get', this.endpoint + 'delete-shift/' + id + '?token=' + this.token)
						.then((data) => {
							console.log(data);
						})
						.catch((error) => {
							this.setNotif({
								type: 2,
								msg: "Greška na serveru! Nije moguće ukloniti smjenu"
							});
							console.log(error.request);
						})
					this.$store.state.user.salon.shifts = this.user.salon.shifts.filter((d) => d.id != id);
				}
			},
			getDay() {
				return this.current_date.getDay() == 0 ? 7 : this.current_date.getDay();
			},
			getNextWeek() {
				var date = new Date(this.current_date);
				var index = date.getDay() == 0 ? 6 : date.getDay() - 1;

				date.setDate(date.getDate() - (index));
				date.setDate(date.getDate() + 7);
				this.start = date.toDateString();


				//reversing the day back to this day in the new week so if today is wed in the current week then after going back to the week start and adding 7 days we will then reverse the day back to wed
				date.setDate(date.getDate() + (index));
				this.current_date = new Date(date);

				date.setDate(date.getDate() - (index));
				date.setDate(date.getDate() + 6);
				this.end = date.toDateString();
				this.getWeekSchedule();
			},
			getPrevWeek() {
				var date = new Date(this.current_date);
				var index = date.getDay() == 0 ? 6 : date.getDay() - 1;
				date.setDate(date.getDate() - index);
				date.setDate(date.getDate() - 7);
				this.start = date.toDateString();

				//reversing the day back to this day in the new week so if today is wed in the current week then after going back to the week start and adding 7 days we will then reverse the day back to wed
				date.setDate(date.getDate() + (index));
				this.current_date = new Date(date);

				date.setDate(date.getDate() - (index));
				date.setDate(date.getDate() + 6);
				this.end = date.toDateString();
				this.getWeekSchedule();
			},
			createShift() {
				if (this.loader) {
					return false;
				}

				this.loader = true;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'add-shift?token=' + this.token,
						details: this.shift
					}).then((data) => {
						console.log(data);
						if (data.data.status) {
							this.setNotif({
								type: 1,
								msg: "Smjena je uspješno dodana."
							});
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							document.getElementById('closeShift').click();
						} else {
							this.setNotif({
								type: 2,
								msg: data.data.msg
							});
						}
						this.loader = false;
						this.shedulemessage = false;
						this.shiftmessage = true;
						this.shiftEmplmessage = false;
					})
					.catch((error) => {
						if (error.request.status == 422) {
							this.$store.dispatch("handleError", error);
						} else {
							this.setNotif({
								type: 2,
								msg: "Greška na serveru"
							});
						}
						console.log(error.request);
						this.loader = false;
						this.shedulemessage = false;
						this.shiftmessage = true;
						this.shiftEmplmessage = false;
					})
			},
			save() {
				if (this.loader) {
					return false;
				}
				this.loader = true;
				// console.log(this.days);
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'working-hours?token=' + this.token,
						details: {
							data: JSON.stringify(this.days)
						}
					}).then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.setNotif({
								type: 1,
								msg: "Radno vrijeme je ažurirano."
							});
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
						} else {
							this.setNotif({
								type: 2,
								msg: data.data.msg
							});
						}
						this.loader = false;
						this.shedulemessage = true;
						this.shiftmessage = false;
						this.shiftEmplmessage = false;
					})
					.catch((error) => {
						this.setNotif({
							type: 2,
							msg: "Dogodila se greška na serveru!"
						});
						console.log(error.request);
						this.shedulemessage = true;
						this.shiftmessage = false;
						this.shiftEmplmessage = false;
					});
			},
			saveSchedule() {
				if (this.loader) {
					return false;
				}
				this.loader = true;
				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'schedule?token=' + this.token,
						details: {
							data: JSON.stringify(this.schedules)
						}
					}).then((data) => {
						if (data.data.status) {
							this.setNotif({
								type: 1,
								msg: "Raspored je ažuriran."
							});
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
						} else {
							if (data.data.affecteds) {
								this.affecteds = data.data.affecteds;
								window.$("#changeEmployee").modal('show');
							}
							this.setNotif({
								type: 2,
								msg: data.data.msg
							});
						}
						this.loader = false;
					})
					.catch((error) => {
						this.loader = false;
						this.setNotif({
							type: 2,
							msg: "Dogodila se greška na serveru"
						});
						console.log(error.request);
					});
			},
			getWeekSchedule() {
				this.loadingSchedule = true;
				this.$store.dispatch('get', this.endpoint + 'get-schedule/' + this.current_date.getWeekNumber() + "/" + this.current_date.getFullYear() + "?token=" + this.token)
					.then((data) => {
						// console.log(data);
						// if(this.current_date.getWeekNumber() == data.data.week){
						this.sortWorkingSchedules(data.data.schedules);
						this.loadingSchedule = false;
						// }
					})
					.catch((error) => {
						console.log(error.request);
						this.loadingSchedule = false;
					})

			},
			sortWorkingSchedules(data) {
				var schds = data;
				this.schedules = this.schedules.map((employee) => {
					employee.schedules = employee.schedules.map((schs) => {
						var empl = schds.find((empl) => (empl.employee_id == employee.employee.id && schs.day == empl.day));
						if (empl) {
							schs.value = empl.shift_id;
						} else {
							schs.value = 0;
						}

						return schs;
					});

					employee.week = this.current_date.getWeekNumber();
					employee.year = this.current_date.getFullYear();
					employee.start = new Date(this.start);

					return employee;
				});
			},
			getDateRange() {
				var date = new Date(this.current_date);
				var index = date.getDay() == 0 ? 6 : date.getDay() - 1;
				date.setDate(date.getDate() - index);
				this.start = date.toDateString();
				date.setDate(date.getDate() + 6);
				this.end = date.toDateString();

			},
			initialiseSchedules() {
				this.schedules = this.user.salon.employees.map((d) => {
					var shift = {
						schedules: []
					};
					shift.week = this.current_date.getWeekNumber();
					shift.year = this.current_date.getFullYear();
					shift.employee = d;

					shift.schedules.push({
						value: 0,
						day: 'mon'
					});
					shift.schedules.push({
						value: 0,
						day: 'tue'
					});
					shift.schedules.push({
						value: 1,
						day: 'wed'
					});
					shift.schedules.push({
						value: 0,
						day: 'thu'
					});
					shift.schedules.push({
						value: 0,
						day: 'fri'
					});
					shift.schedules.push({
						value: 0,
						day: 'sat'
					});
					shift.schedules.push({
						value: 0,
						day: 'sun'
					});

					shift.start = new Date(this.start);
					return shift;
				});

			}
		},
		created() {
			Date.prototype.getWeekNumber = function() {
				var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
				var dayNum = d.getUTCDay() || 7;
				d.setUTCDate(d.getUTCDate() + 4 - dayNum);
				var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
				return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
			};

			this.getDateRange();
			this.initialiseSchedules();
			this.getWeekSchedule();

			var working_hours = this.user.salon.working_hours;
			this.days = this.days.map((d) => {
				var current = working_hours.find((t) => t.day == d.value);
				if (current) {
					d.data.start = current.start == '00:00:00' ? '' : current.start;
					d.data.ps = current.ps == '00:00:00' ? '' : current.ps;
					d.data.pk = current.pk == '00:00:00' ? '' : current.pk;
					d.data.end = current.end == '00:00:00' ? '' : current.end;
				}
				return d;
			});


		}
	}

</script>
<style scoped>
	.affected {
		border: 1px solid lightgray;
		border-radius: 4px;
		padding: 10px;
	}

</style>
